module.exports = __webpack_public_path__ + "img/Trustpilot_brandmark_wht_RGB.3b9826e4.svg";